var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-2"},[_c('v-col',{attrs:{"cols":"auto"}},[_c('botao-avancar'),_c('botao-anterior')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }